import React from "react"
import styles from "../../styles/bottombox.css"


export default class BottombBtnBox extends React.Component {

  constructor(){
    super()

  }

  componentDidMount(){
  }

  componentWillUnmount(){
  }


  render(){



    return(
      <div className={"alert-box-footer-wrap " + this.props.addclass} >

        <div className="btn-box inline">
          <button className="create-btn midium" onClick = {this.props.btnClickHandler}>参加予定登録</button>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/parts/BottomBtnBox.js